import { r as S, c as I, h as b, g as z } from "./main-bb89b2f2.js";
import { d as T, $ as y } from "./screen.store-835df690-461bc8b5.js";
import { g as C } from "./getHTMLElements-42e066e3-4491c4a7.js";
import { r as k } from "./range-8bdec96a-0440657e.js";
import "vue";
import "./toNumber-f405d8e0-e5c83f11.js";
const L = (s) => s.split(",").map((e) => ":scope>" + e).join();
function E(s, e) {
  return L(e).split(",").map((i) => C(s, i)).flat();
}
function O(s) {
  const { activeTabIndex: e, tabsCount: i } = s;
  return i === 1 ? {
    leftNeighbor: null,
    rightNeighbor: null
  } : e === 0 ? {
    leftNeighbor: null,
    rightNeighbor: 1
  } : e === i - 1 ? {
    leftNeighbor: e - 1,
    rightNeighbor: null
  } : {
    leftNeighbor: e - 1,
    rightNeighbor: e + 1
  };
}
function A(s) {
  const { availableWidth: e, tabsCount: i, activeTabIndex: o, optimize: t } = s, n = 40, r = 112, p = (i - 1) * 16, a = {};
  if (!t)
    return k(0, i).forEach((d) => a[d] = "grow"), a;
  const v = i * n + p;
  if (!(v <= e))
    return console.warn("[patternlib-storytabs] You have provided too many tabs. Please make sure there is enough space available"), k(0, i).forEach((d) => a[d] = "collapsed"), a;
  if (i * r + p <= e)
    return k(0, i).forEach((d) => a[d] = "grow"), a;
  k(0, i).forEach((d) => {
    a[d] = "collapsed";
  });
  let l = e - v;
  const w = r - n;
  l >= w && (a[o] = "grow", l -= w);
  let { leftNeighbor: m, rightNeighbor: h } = O(s), f = "left";
  for (; l >= w; ) {
    l -= w;
    let d = 0;
    f === "left" && h && h <= i - 1 ? (d = h, h++) : f === "left" && (!h || h >= i - 1) && (d = m, m--), f === "right" && m && m >= 0 ? (d = m, m--) : f === "right" && (!m || m <= 0) && (d = h, h++), f = f === "left" ? "right" : "left", a[d] = "grow";
  }
  return a;
}
const W = '*,:after,:before{border-color:var(--color-neutral-steel-200);border-style:solid;border-width:0;box-sizing:border-box}a{color:inherit;text-decoration:inherit}audio,canvas,embed,iframe,img,object,svg,video{display:block;vertical-align:middle}button,input,optgroup,select,textarea{font-feature-settings:inherit;color:inherit;font-family:inherit;font-size:100%;font-variation-settings:inherit;font-weight:inherit;letter-spacing:inherit;line-height:inherit;margin:0;padding:0}blockquote,dd,dl,fieldset,figure,h1,h2,h3,h4,h5,h6,hr,p,pre{margin:0}fieldset,legend{padding:0}.absolute{position:absolute}.relative{position:relative}.flex{display:flex}.hidden{display:none}.flex-grow{flex-grow:1}.cursor-pointer{cursor:pointer}.flex-col{flex-direction:column}.border{border-width:1px}.font-text-bold{font-family:var(--copytext-font-family-bold)}.text-copy-small-uniform{font-size:var(--copytext-font-size-small-noctx);line-height:var(--copytext-line-height-small-noctx)}.outline{outline-style:solid}.transition{transition-duration:.15s;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,-webkit-backdrop-filter;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter,-webkit-backdrop-filter;transition-timing-function:cubic-bezier(.4,0,.2,1)}.storytabs{background:var(--storytabs-surface-default);border:none;display:inline-flex;outline:none;position:relative;-webkit-user-select:none;-moz-user-select:none;user-select:none}.storytabs--mobile{flex-direction:column}.storytabs--mobile .storytabs-items{overflow-x:scroll}.storytabs--shadow-left:before{background-image:linear-gradient(90deg,rgba(0,0,0,.2),transparent);left:0}.storytabs--shadow-left:before,.storytabs--shadow-right:after{bottom:0;content:"";height:28px;pointer-events:none;position:absolute;top:0;width:3px}.storytabs--shadow-right:after{background-image:linear-gradient(270deg,rgba(0,0,0,.2),transparent);right:0}.storytabs-items{display:flex;gap:8px;width:100%}.storytabs-items--vertical{flex-direction:column;gap:0}.st-group{display:flex;gap:8px;position:relative}.st-group,.st-item{flex-grow:1;transition:all .2s ease-out;width:0}.st-item{align-items:flex-start;background:inherit;border:none;color:var(--storytabs-text-default);cursor:pointer;display:flex;flex-direction:column;font-family:var(--copytext-font-family-bold);font-size:var(--copytext-font-size-small-noctx);letter-spacing:1px;line-height:var(--copytext-line-height-small-noctx);outline:none}.st-item .st-item-divider{border-top:2px solid var(--storytabs-stroke-default);width:100%}.st-item:hover:not(:disabled,:active){color:var(--storytabs-text-hover)}.st-item:hover:not(:disabled,:active) .st-item-divider{border:none;border-top:2px solid var(--storytabs-stroke-hover)}.st-item:hover:not(:disabled,:active) .st-item-divider-vertical{border:none;border-left:2px solid var(--storytabs-stroke-hover)}.st-item:active:not(:disabled){color:var(--storytabs-text-active)}.st-item:active:not(:disabled) .st-item-divider{border:none;border-top:2px solid var(--storytabs-stroke-active)}.st-item:active:not(:disabled) .st-item-divider-vertical{border:none;border-left:2px solid var(--storytabs-stroke-active)}.st-item:focus:not(:hover,:disabled,:active):not(.st-item--suppressFocusStyle){border:2px solid #000}.st-item:focus:not(:hover,:disabled,:active):not(.st-item--suppressFocusStyle) .st-item-divider{border:none;border-top:2px solid var(--storytabs-stroke-focus)}.st-item:focus:not(:hover,:disabled,:active):not(.st-item--suppressFocusStyle) .st-item-divider-vertical{border:none;border-left:2px solid var(--storytabs-stroke-focus)}.st-item--default{color:var(--storytabs-text-default)}.st-item--default .st-item-divider{border:none;border-top:2px solid var(--storytabs-stroke-default)}.st-item--default .st-item-divider-vertical{border:none;border-left:2px solid var(--storytabs-stroke-default)}.st-item--active{color:var(--storytabs-text-active)!important}.st-item--active .st-item-divider{border:none!important;border-top:2px solid var(--storytabs-stroke-active)!important}.st-item--active .st-item-divider-vertical{border:none!important;border-left:2px solid var(--storytabs-stroke-active)!important}.st-item--disabled{color:var(--storytabs-text-disabled);cursor:default}.st-item--disabled .st-item-divider{border:none;border-top:2px solid var(--storytabs-stroke-disabled)}.st-item--disabled .st-item-divider-vertical{border:none;border-left:2px solid var(--storytabs-stroke-disabled)}.st-item--success{color:var(--storytabs-text-success)}.st-item--success .st-item-divider{border:none;border-top:2px solid var(--storytabs-stroke-success)}.st-item--success .st-item-divider-vertical{border:none;border-left:2px solid var(--storytabs-stroke-success)}.st-item--error{color:var(--storytabs-text-error)}.st-item--error .st-item-divider{border:none;border-top:2px solid var(--storytabs-stroke-error)}.st-item--error .st-item-divider-vertical{border:none;border-left:2px solid var(--storytabs-stroke-error)}.st-item-substep{min-width:24px}.st-item-id{height:24px;margin-bottom:2px}.st-item-label{line-clamp:3;-webkit-line-clamp:3;-webkit-box-orient:vertical;display:-webkit-box;margin-top:8px;overflow:hidden;text-align:left;text-overflow:ellipsis;white-space:normal}.st-layout--collapsed.st-group,.st-layout--collapsed.st-item{flex:0;min-width:40px}.st-layout--collapsed.st-group .st-item-label,.st-layout--collapsed.st-item .st-item-label{display:none}.st-layout--grow.st-group,.st-layout--grow.st-item{flex-grow:1;min-width:40px}.st-layout--vertical{align-items:center;display:flex;flex-direction:row;width:100%}.st-layout--vertical .st-item-id{width:20px}.st-layout--vertical .st-item-label{margin-top:0}.st-layout--vertical .st-item-divider-vertical{border-width:0;border-left:2px solid var(--storytabs-stroke-default);height:40px;margin:0 20px 0 12px}.st-label{font-family:var(--copytext-font-family-bold);font-size:var(--copytext-font-size-small-noctx);letter-spacing:1px;line-height:var(--copytext-line-height-small-noctx);margin-top:8px;text-align:left;white-space:normal;width:100%}@media (min-width:768px){.storytabs-items{gap:16px}.st-layout--grow.st-group,.st-layout--grow.st-item{min-width:112px}}.static{position:static}.grow{flex-grow:1}.resize{resize:both}', F = W, R = class {
  constructor(s) {
    S(this, s), this.change = I(this, "lhChangeItem", 7), this.suppressFocusStyle = !1, this.windowResizeListener = null, this.scrollResizeListener = null, this.clickStorytabsItem = (e) => () => {
      this.suppressFocusStyle = !0, this.triggerRerender();
      const i = this.getTabs(), o = i.find((t, n) => {
        const r = this.getStoryTabItemValue(t.domElement);
        return n === e || r === e;
      });
      o && !o.domElement.disabled && (i.forEach((t) => {
        t === o ? t.domElement.active = !0 : t.domElement.active = !1;
      }), this.activeItemValue = e, this.change.emit({ itemId: e }));
    }, this.blurHandler = () => {
      this.suppressFocusStyle = !1, this.triggerRerender();
    }, this.containerWidth = "auto", this.direction = "horizontal", this.tabItems = [], this.activeItemValue = 0, this.renderState = 0;
  }
  handleItemChange() {
    this.tabItems = this.queryStoryTabs();
  }
  /**
   * Public function to re-render and update the Storytabs
   */
  async updateStorytabs() {
    this.tabItems = this.queryStoryTabs();
  }
  connectedCallback() {
    this.windowResizeListener = T(() => {
      this.triggerRerender();
    }, 500), window.addEventListener("resize", this.windowResizeListener);
  }
  componentDidLoad() {
    queueMicrotask(() => {
      this.updateStorytabs();
    }), this.scrollResizeListener = T(() => {
      const s = this.scrollContainer.scrollLeft, e = this.scrollContainer.scrollWidth - this.scrollContainer.clientWidth;
      this.scrollContainer.scrollWidth <= this.scrollContainer.clientWidth ? this.rootContainer.classList.remove("storytabs--shadow-left", "storytabs--shadow-right") : (this.rootContainer.classList.toggle("storytabs--shadow-left", s > 0), this.rootContainer.classList.toggle("storytabs--shadow-right", s < e));
    }, 100), this.scrollContainer.addEventListener("scroll", this.scrollResizeListener);
  }
  disconnectedCallback() {
    window.removeEventListener("resize", this.windowResizeListener), this.scrollContainer.removeEventListener("scroll", this.scrollResizeListener);
  }
  /**
   * Queries all substeps. Categories them into single tabs and tab-groups.
   */
  queryStoryTabs(s = this.hostElement) {
    let e = 0;
    const i = E(s, "*").map((o) => {
      if (o.nodeName === "PATTERNLIB-STORYTABS-SUBSTEPS") {
        const n = {
          type: "tab-group",
          groupPosition: e,
          items: E(o, "patternlib-storytabs-item").map((r) => ({
            domElement: r,
            isSubNavItem: !0,
            groupPosition: e,
            type: "tab"
          }))
        };
        return e++, n;
      }
      const t = {
        domElement: o,
        isSubNavItem: !1,
        groupPosition: e,
        type: "tab"
      };
      return e++, t;
    }).flat();
    if (i.length === 0)
      throw new Error("[patternlib-storytabs] Must have at least one storytabsItem");
    return i;
  }
  isGroupTab(s) {
    return s.type === "tab-group";
  }
  /**
   * Tries to find an active tab in a group. If not found, fallback to the first element of the group
   */
  getFirstOrActiveOfGroup(s) {
    var e;
    const i = this.getStoryTabItemValue((e = this.getActiveTab()) === null || e === void 0 ? void 0 : e.activeTab.domElement), o = s.items.find((t) => t.domElement.value === i || t.domElement.value === i);
    return o ?? s.items[0];
  }
  getTabGroups() {
    var s, e;
    const i = A({
      tabsCount: this.tabItems.length,
      activeTabIndex: (e = (s = this.getActiveTab()) === null || s === void 0 ? void 0 : s.activeTabIndex) !== null && e !== void 0 ? e : 0,
      availableWidth: this.hostElement.offsetWidth,
      optimize: y.mdAndUp
    }), o = [];
    return this.tabItems.forEach((t, n) => {
      const r = (c) => c.type === "tab-group", u = i[n], p = n === 0, a = 24, v = y.mdAndUp ? 16 : 8, x = () => {
        let c = 0;
        return r(t) && y.mobile ? c = a * t.items.length + v * (t.items.length - 1) : c = y.mobile ? 64 : 112, {
          grow: u === "grow",
          collapsed: u === "collapsed",
          isHorizontal: this.direction === "horizontal",
          isVertical: this.direction !== "horizontal",
          orderPosition: t.groupPosition,
          minWidth: c
        };
      }, g = (c) => {
        const l = c.domElement;
        return Object.assign(Object.assign({}, c), { isFirst: p, isDefault: !l.disabled && !l.active && !l.success && !l.error, isDisabled: l.disabled, isActive: !l.disabled && !l.success && !l.error && l.active, isSuccess: l.success, isError: l.error });
      };
      r(t) && o.push({
        type: "tab-group",
        groupPosition: t.groupPosition,
        layout: x(),
        items: t.items.map((c) => Object.assign(Object.assign({}, c), { state: g(c) }))
      }), r(t) || o.push(Object.assign(Object.assign({ type: "tab" }, t), { layout: x(), state: g(t) }));
    }), o;
  }
  /**
   * Public function to set active item of the Storytabs
   */
  async setStorytabsItemToActive(s) {
    this.clickStorytabsItem(s);
  }
  getTabs() {
    return this.tabItems.map((s) => this.isGroupTab(s) ? s.items : s).flat();
  }
  triggerRerender() {
    this.renderState = (/* @__PURE__ */ new Date()).getTime();
  }
  getActiveTab() {
    const e = this.getTabs().find((i, o) => {
      const t = this.getStoryTabItemValue(i.domElement);
      return o === this.activeItemValue || t === this.activeItemValue;
    });
    if (e)
      return {
        activeTabIndex: e.groupPosition,
        activeTab: e
      };
  }
  getStoryTabItemValue(s) {
    return s.value;
  }
  getStateClasses(s) {
    const { isDefault: e, isDisabled: i, isActive: o, isError: t, isSuccess: n } = s;
    return {
      ["st-item"]: !0,
      ["st-item--default"]: e,
      ["st-item--disabled"]: i,
      ["st-item--active"]: o,
      ["st-item--success"]: n,
      ["st-item--error"]: t,
      ["st-item--suppressFocusStyle"]: this.suppressFocusStyle
    };
  }
  getLayoutClasses(s, e = "st-layout") {
    const { collapsed: i, grow: o, isHorizontal: t, isVertical: n } = s;
    return {
      [`${e}--collapsed`]: i,
      [`${e}--grow`]: o,
      [`${e}--horizontal`]: t,
      [`${e}--vertical`]: n
    };
  }
  render() {
    const s = (t) => `${t.groupPosition < 9 ? "0" : ""}${t.groupPosition + 1}`, e = this.direction === "horizontal", i = !e || !y.mobile && e, o = this.getActiveTab();
    return b("div", { class: {
      storytabs: !0,
      "storytabs--mobile": y.mobile
    }, style: { width: this.containerWidth }, ref: (t) => this.rootContainer = t }, b("div", { class: {
      "storytabs-items": !0,
      "storytabs-items--vertical": this.direction !== "horizontal"
    }, ref: (t) => this.scrollContainer = t }, this.getTabGroups().map((t, n) => {
      if (this.isGroupTab(t)) {
        const r = this.getFirstOrActiveOfGroup(t).domElement.label;
        return b("div", { "data-group": !0, class: Object.assign({ ["st-group"]: !0 }, this.getLayoutClasses(t.layout)), style: { minWidth: `${t.layout.minWidth}px` } }, t.items.map((u, p) => {
          var a;
          const v = u.domElement, x = (a = this.getStoryTabItemValue(v)) !== null && a !== void 0 ? a : p, g = p === 0;
          return b("button", { class: Object.assign(Object.assign({}, this.getStateClasses(u.state)), { "st-item-substep": !0 }), onBlur: this.blurHandler, onClick: this.clickStorytabsItem(x), disabled: v.disabled }, b("div", { class: "st-item-id" }, g ? s(u) : ""), b("div", { class: {
            "st-item-divider": !0,
            "st-item-divider-vertical": !t.layout.isHorizontal
          } }), i && b("div", { class: "st-item-label" }, g ? r : ""));
        }));
      } else {
        const r = t.domElement, u = r.value != null ? r.value : n;
        return b("button", { class: Object.assign(Object.assign({}, this.getLayoutClasses(t.layout)), this.getStateClasses(t.state)), onBlur: this.blurHandler, onClick: this.clickStorytabsItem(u), disabled: r.disabled, style: { minWidth: `${t.layout.minWidth}px` } }, b("div", { class: "st-item-id" }, s(t)), b("div", { class: {
          "st-item-divider": t.layout.isHorizontal,
          "st-item-divider-vertical": !t.layout.isHorizontal
        } }), i && b("div", { class: "st-item-label" }, t.domElement.label));
      }
    })), !i && b("div", { class: "st-label" }, o == null ? void 0 : o.activeTab.domElement.label));
  }
  get hostElement() {
    return z(this);
  }
};
R.style = F;
export {
  R as patternlib_storytabs
};
